import React from 'react';
import './SpinnerComponent.css';

const SpinnerComponent = () => {
  return (
    <div className="spinner-container">
      <div className="spinner"></div>
    </div>
  );
};

export default SpinnerComponent;
